import { render, staticRenderFns } from "./LogoSetEditor.vue?vue&type=template&id=0bfd1666&"
import script from "./LogoSetEditor.vue?vue&type=script&lang=js&"
export * from "./LogoSetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports